import PropTypes from 'prop-types';
import { format } from 'date-fns';

const PostCard = ({
  title = '',
  description = '',
  type = 'resource',
  publishedAt = new Date(),
  timeToRead = 0,
  author = null,
  cover = '',
}) => (
  <div className="flex flex-col h-full rounded-md shadow-xl hover:shadow-2xl transition-shadow cursor-pointer bg-white text-black">
    <img
      src={cover}
      alt="Blog Post 1"
      className="rounded-t-md object-cover max-h-64 w-full"
    />
    <div className="flex-1 p-8 overflow-hidden flex flex-col justify-between">
      <div>
        <span
          className={`capitalize text-sm font-semibold rounded-full px-4 py-1 inline-block mb-3 ${
            type === 'resource'
              ? 'bg-green-200 text-green-700'
              : type === 'article'
              ? 'bg-purple-200 text-purple-700'
              : 'bg-red-200 text-red-700'
          }`}
        >
          {type}
        </span>
        <p className="text-xl font-semibold mb-4">{title}</p>
        <p className="text-gray-500 leading-normal text-lg mb-8">
          {description}
        </p>
      </div>
      <div className="flex items-center">
        <img
          src={author?.picture}
          alt="Author 1"
          className="w-12 h-12 mr-4 rounded-full ring ring-red-200"
        />
        <div>
          <p className="font-semibold text-lg leading-6">
            {author?.displayName}
          </p>
          <p className="text-gray-500 text-sm">
            {format(publishedAt, 'MMM, dd yyyy')} - {timeToRead} min read
          </p>
        </div>
      </div>
    </div>
  </div>
);

PostCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(['article', 'video', 'resource']),
  publishedAt: PropTypes.object,
  timeToRead: PropTypes.number,
  author: PropTypes.shape({
    displayName: PropTypes.string,
    picture: PropTypes.string,
  }),
  cover: PropTypes.string,
};

export default PostCard;
